import { render, staticRenderFns } from "./BaseMaxWidthContainer.vue?vue&type=template&id=61a7566e&"
import script from "./BaseMaxWidthContainer.vue?vue&type=script&lang=ts&"
export * from "./BaseMaxWidthContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports